import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios'
import { BASE_URL } from '../apiConfig';

// Employee Info API
export const postEmployeesInfo = createAsyncThunk(
  'hrForm/postEmployeesInfo',
  async ({ jwtBearer, requestBody,user_id }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}hr/emp/info/?user_id=${user_id}`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + jwtBearer,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (!response.ok) return rejectWithValue(responseData);
      return responseData;
    } catch (error) {
      return rejectWithValue({ errorMessage: error.toString() });
    }
  }
);

export const getPostEmployessInfo = createAsyncThunk(
  'hrForm/getPostEmployessInfo',
  async ({ jwtBearer, user_id }, { rejectWithValue }) => {
    try {
      if (user_id === null) return null;

      const response = await fetch(`${BASE_URL}hr/get/emp/info/?user_id=${user_id}`, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + jwtBearer,
          'Content-Type': 'application/json',
        },
      });
      const responseData = await response.json();
      if (!response.ok) return rejectWithValue(responseData);
      return responseData;
    } catch (error) {
      if (error.response?.status === 401) window.location.reload();
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ESI API
export const postESIInfo = createAsyncThunk(
  'hrForm/postESIInfo',
  async ({ jwtBearer, requestBody,user_id }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}hr/esi/form/?user_id=${user_id}`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + jwtBearer,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (!response.ok) return rejectWithValue(responseData);
      return responseData;
    } catch (error) {
      return rejectWithValue({ errorMessage: error.toString() });
    }
  }
);

export const getESIInfo = createAsyncThunk(
  'hrForm/getESIInfo',
  async ({ jwtBearer, user_id }, { rejectWithValue }) => {
    try {
      if (user_id === null) return null;

      const response = await fetch(`${BASE_URL}hr/get/esi/data/?user_id=${user_id}`, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + jwtBearer,
          'Content-Type': 'application/json',
        },
      });
      const responseData = await response.json();
      if (!response.ok) return rejectWithValue(responseData);
      return responseData;
    } catch (error) {
      if (error.response?.status === 401) window.location.reload();
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Compliance API
export const postComplianceInfo = createAsyncThunk(
  'hrForm/postComplianceInfo',
  async ({ jwtBearer, requestBody,user_id }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}hr/compliance/form/?user_id=${user_id}`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + jwtBearer,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (!response.ok) return rejectWithValue(responseData);
      return responseData;
    } catch (error) {
      return rejectWithValue({ errorMessage: error.toString() });
    }
  }
);

export const getComplianceInfo = createAsyncThunk(
  'hrForm/getComplianceInfo',
  async ({ jwtBearer, user_id }, { rejectWithValue }) => {
    try {
      if (user_id === null) return null;

      const response = await fetch(`${BASE_URL}hr/get/compliance/data/?user_id=${user_id}`, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + jwtBearer,
          'Content-Type': 'application/json',
        },
      });
      const responseData = await response.json();
      if (!response.ok) return rejectWithValue(responseData);
      return responseData;
    } catch (error) {
      if (error.response?.status === 401) window.location.reload();
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getAllFormsData = createAsyncThunk(
  'hrForm/getAllFormsData',
  async ({ jwtBearer }, { rejectWithValue }) => {
    try {

      const response = await fetch(`${BASE_URL}hr/get/form/data/`, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + jwtBearer,
          'Content-Type': 'application/json',
        },
      });
      const responseData = await response.json();
      if (!response.ok) return rejectWithValue(responseData);
      return responseData;
    } catch (error) {
      if (error.response?.status === 401) window.location.reload();
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadPhotograph = createAsyncThunk(
  'esi/uploadPdf',
  async ({ user_id, file, file_type }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('user_id', user_id);
      formData.append('file_type', file_type);
      formData.append('file', file);

      const response = await axios.post(`${BASE_URL}hr/upload/photograph/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadPdfToS3 = createAsyncThunk(
  'both/uploadPdf',
  async ({ user_id, file, file_type }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('user_id', user_id);
      formData.append('file_type', file_type);
      formData.append('file', file);

      const response = await axios.post(`${BASE_URL}hr/upload/esi/compliance/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadFinalPdfToS3 = createAsyncThunk(
  'esi/uploadPdf',
  async ({ user_id,  file_type }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('user_id', user_id);
      formData.append('file_type', file_type);
      // formData.append('file', file);

      const response = await axios.post(`${BASE_URL}hr/upload/esi/compliance/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createOxyzoEsign = createAsyncThunk(
  'createOxyzoEsign',
  async ({ requestBody, jwtBearer }, { rejectWithValue }) => {
    // console.log("Request Body:", requestBody);
    // console.log("jwtBearer :", jwtBearer);
    try {
      const response = await axios.post(
        `${BASE_URL}hr/e-sign/`,
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error Response: ", error);
      const errorMessage = error?.response?.data?.message || 'An unexpected error occurred.';
      const errorCode = error?.response?.data?.code || 400;
      return rejectWithValue({
        code: errorCode,
        message: errorMessage
      });
    }
  }
);

export const getEsginStatus = createAsyncThunk(
  'hrForm/getEsginStatus',
  async ({ jwtBearer,request_id }, { rejectWithValue }) => {
    console.log("my req id",request_id,jwtBearer)
    try {

      const response = await fetch(`${BASE_URL}hr/${request_id}/getEsignDetailsByRequestId/`, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + jwtBearer,
          'Content-Type': 'application/json',
        },
      });
      const responseData = await response.json();
      if (!response.ok) return rejectWithValue(responseData);
      return responseData;
    } catch (error) {
      if (error.response?.status === 401) window.location.reload();
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// export const updateEsigned = createAsyncThunk(
//   'hrForm/getEsginStatus',
//   async ({ jwtBearer,request_id }, { rejectWithValue }) => {
//     console.log("my req id",request_id,jwtBearer)
//     try {

//       const response = await fetch(`${BASE_URL}hr/${request_id}/updateStatus/`, {
//         method: 'POST',
//         headers: {
//           Authorization: 'Bearer ' + jwtBearer,
//           'Content-Type': 'application/json',
//         },
//       });
//       const responseData = await response.json();
//       if (!response.ok) return rejectWithValue(responseData);
//       return responseData;
//     } catch (error) {
//       if (error.response?.status === 401) window.location.reload();
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

export const updateSectionStatus = createAsyncThunk(
  'hrForm/updateSectionStatus',
  async ({ jwtBearer, user_id, type, updates }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}hr/update-sections/`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + jwtBearer,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id,
          type,
          updates
        }),
      });
      const responseData = await response.json();
      if (!response.ok) return rejectWithValue(responseData);
      return responseData;
    } catch (error) {
      return rejectWithValue({ errorMessage: error.toString() });
    }
  }
);

const initialState = {
  emp_data: null,
  emp_data_loading: false,
  emp_data_error: null,

  esi_data: null,
  esi_loading: false,
  esi_error: null,

  compliance_data: null,
  compliance_loading: false,
  compliance_error: null,

  all_forms_loading: false,
  all_forms_error: null,
};

const hrFormsSlice = createSlice({
  name: 'hrForm',
  initialState,
  reducers: {
    clearAllData: (state) => {
      state.emp_data = null;
      state.esi_data = null;
      state.compliance_data = null;
      state.emp_data_error = null;
      state.esi_error = null;
      state.compliance_error = null;
    },
    clearEmployeeData: (state) => {
      state.emp_data = null;
      state.emp_data_error = null;
    },
    clearESIData: (state) => {
      state.esi_data = null;
      state.esi_error = null;
    },
    clearComplianceData: (state) => {
      state.compliance_data = null;
      state.compliance_error = null;
    }
  },
  extraReducers: (builder) => {
    // Employee Info reducers
    builder
      .addCase(getPostEmployessInfo.pending, (state) => {
        state.emp_data_loading = true;
        state.emp_data_error = null;
      })
      .addCase(getPostEmployessInfo.fulfilled, (state, action) => {
        state.emp_data_loading = false;
        state.emp_data = action.payload?.emp_info_data || null;
      })
      .addCase(getPostEmployessInfo.rejected, (state, action) => {
        state.emp_data_loading = false;
        state.emp_data_error = action.payload?.errorMessage || 'Failed to fetch employee info';
      })

      // ESI reducers
      .addCase(getESIInfo.pending, (state) => {
        state.esi_loading = true;
        state.esi_error = null;
      })
      .addCase(getESIInfo.fulfilled, (state, action) => {
        state.esi_loading = false;
        state.esi_data = action.payload?.emp_esi_data || null;
      })
      .addCase(getESIInfo.rejected, (state, action) => {
        state.esi_loading = false;
        state.esi_error = action.payload?.errorMessage || 'Failed to fetch ESI info';
      })

      // Compliance reducers
      .addCase(getComplianceInfo.pending, (state) => {
        state.compliance_loading = true;
        state.compliance_error = null;
      })
      .addCase(getComplianceInfo.fulfilled, (state, action) => {
        state.compliance_loading = false;
        state.compliance_data = action.payload?.emp_compliance_data || null;
      })
      .addCase(getComplianceInfo.rejected, (state, action) => {
        state.compliance_loading = false;
        state.compliance_error = action.payload?.errorMessage || 'Failed to fetch compliance info';
      })

      // All Forms Data reducers

      // All Forms Data reducers
      .addCase(getAllFormsData.pending, (state) => {
        state.all_forms_loading = true;
        state.all_forms_error = null;
        // Set individual loading states if needed
        state.emp_data_loading = true;
        state.esi_loading = true;
        state.compliance_loading = true;
      })
      .addCase(getAllFormsData.fulfilled, (state, action) => {
        state.all_forms_loading = false;
        state.emp_data_loading = false;
        state.esi_loading = false;
        state.compliance_loading = false;

        // Update each form's data based on API response
        state.emp_esign_data = action.payload?.emp_esign_data || null;
        // console.log("state.emp_arrears_data", state.emp_arrears_data);
        state.emp_esi_data = action.payload?.emp_esi_data || null;
        state.emp_compliance_data = action.payload?.emp_compliance_data || null;
      })
      .addCase(getAllFormsData.rejected, (state, action) => {
        state.all_forms_loading = false;
        state.emp_data_loading = false;
        state.esi_loading = false;
        state.compliance_loading = false;
        state.all_forms_error = action.payload?.errorMessage || 'Failed to fetch all forms data';
      })
  },
});

export const {
  clearAllData,
  clearEmployeeData,
  clearESIData,
  clearComplianceData
} = hrFormsSlice.actions;

export default hrFormsSlice.reducer;